export const strings = {
  en: {
    descriptionTitle: ({ nonprofitName = "a nonprofit" }) => `You've just made an impact for ${nonprofitName}`,
    descriptionSubtitle: () => `Check out the impact your purchase made below.`,
    yourImpactTitle: () => `You’ve Funded`,
    communityImpactTitle: () => `Together we’re funding`,
    personalImpactLinkCopy: ({ name = "" }) => `Learn about ${name}`,
    communityImpactLinkCopy: ({ name = "" }) => `See all of the impact by the ${name} community`,
    // share modal
    impactShareButton: () => `Share to Grow Your Impact`,
  },
  fr: {
    descriptionTitle: ({ nonprofitName = "" }) => `Vous avez eu un impact positif sur ${nonprofitName}`, // TODO: Update translation copy SDK-2210
    descriptionSubtitle: ({ causeName = "" }) =>
      `Découvrez quel est l'impact de votre achat chez ${causeName} ci-dessous.`, // TODO: Update translation copy SDK-2210
    yourImpactTitle: () => `Vous avez financé`,
    communityImpactTitle: () => `Ensemble, nous finançons`,
    personalImpactLinkCopy: ({ name = "" }) => `En savoir sur ${name}`,
    communityImpactLinkCopy: ({ name = "" }) => `Voir toutes les contributions de la communauté de ${name}`,
    // share modal
    impactShareButton: () => `Partagez pour augmentez notre cause`,
  },
  de: {
    descriptionTitle: ({ nonprofitName = "" }) => `Du hast soeben einen Beitrag geleistet für ${nonprofitName}`, // TODO: Update translation copy SDK-2210
    descriptionSubtitle: ({ causeName = "" }) =>
      `Erfahre mehr über den Beitrag, den du mit deinem ${causeName} Kauf geleistet hast`, // TODO: Update translation copy SDK-2210
    yourImpactTitle: () => `Sie haben finanziert`,
    communityImpactTitle: () => `Gemeinsam finanzieren wir`,
    personalImpactLinkCopy: ({ name = "" }) => `Mehr über ${name} lernen`,
    communityImpactLinkCopy: ({ name = "" }) =>
      `Informiere dich über den bisher geleisteten Beitrag der ${name} community`,
    // share modal
    impactShareButton: () => `Teil, um unserem Beitrag zu erhöhen`,
  },
  es: {
    descriptionTitle: ({ nonprofitName = "" }) => `Acabas de contribuir con ${nonprofitName}`, // TODO: Update translation copy SDK-2210
    descriptionSubtitle: ({ causeName = "" }) =>
      `Comprueba la contribución que has hecho con tu compra ${causeName} a continuación`, // TODO: Update translation copy SDK-2210
    yourImpactTitle: () => `Has financiado`,
    communityImpactTitle: () => `Juntos estamos financiando`,
    personalImpactLinkCopy: ({ name = "" }) => `Saber de ${name}`,
    communityImpactLinkCopy: ({ name = "" }) => `Mira lo que ha conseguido la comunidad ${name}`,
    // share modal
    impactShareButton: () => "Comparte para aumentar nuestro impacto",
  },
  it: {
    descriptionTitle: ({ nonprofitName = "" }) => `Hai appena fatto la differenza per ${nonprofitName}`, // TODO: Update translation copy SDK-2210
    descriptionSubtitle: ({ causeName = "" }) => `Guarda qui sotto l'impatto del tuo acquisto ${causeName}`, // TODO: Update translation copy SDK-2210
    yourImpactTitle: () => `Hai finanziato`,
    communityImpactTitle: () => `Insieme stiamo finanziando`,
    personalImpactLinkCopy: ({ name = "" }) => `Scopri su ${name}`,
    communityImpactLinkCopy: ({ name = "" }) => `Guarda come la comunità di ${name} fa la differenza`,
    // share modal
    impactShareButton: () => "Condividi, aiutaci a fare la differenza",
  },
  pl: {
    descriptionTitle: ({ nonprofitName = "" }) => `Właśnie wsparłaś_eś ${nonprofitName}!`, // TODO: Update translation copy SDK-2210
    descriptionSubtitle: ({ causeName = "" }) =>
      `Sprawdź niżej, jakiego wsparcia udzieliłaś_eś kupując w ${causeName} `, // TODO: Update translation copy SDK-2210
    yourImpactTitle: () => `Sfinansowałeś(a) `,
    communityImpactTitle: () => `Razem finansujemy`,
    personalImpactLinkCopy: ({ name = "" }) => `Dowiedz się o ${name}`,
    communityImpactLinkCopy: ({ name = "" }) => `Zobacz, ile dobrego zrobiła do tej pory społeczność ${name}`,
    // share modal
    impactShareButton: () => `Udostępnij, by szerzyć naszą misję`,
  },
};
